
	import { Component, Vue } from 'vue-property-decorator';
	import SideBarLevel1 from '@/HostApp/ui/components/Dojo2Vue/SideBarLevel1.vue';
	import SideBarLevel2 from '@/HostApp/ui/components/Dojo2Vue/SideBarLevel2.vue';
	import { serverProps } from '@/Common/Environment/const';

	@Component({
		components: { SideBarLevel2, SideBarLevel1 }
	})
	export default class SideBar extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected get error404(): boolean {
			return !!this.state.error404;
		}

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			return {
				display: 'flex',
				height: this.isMobile ? '0px' : '100%'
			};
		}

		protected get isMobile(): boolean {
			return this.state.isXSClientType;
		}
	}
